import React, { useEffect, useState } from 'react'
import { Checkbox, Col, Divider, Image, Row, Space, Tag } from 'antd'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { EventModal } from 'Components/modal'
import Theme, { MyTheme } from 'Components/common/Theme'
import { ThunderboltOutlined } from '@ant-design/icons'
import { TableListPage } from 'Components/common/Table'
import { ImageFallback, menuReturnPaymentTypes, menuReturnReason, VAT_TYPE } from 'helpers/constanst'
import {
  formValidation,
  getQtyMenu,
  getUomReturnMenu,
  isFormError,
  isFormRequired,
  numberWithComma,
  roundNumber,
} from 'helpers/format'
import { Data, Product } from 'Store/orders/types'
import { appConfig } from 'config'
import { cloneDeep } from 'lodash'
import { CreateReturnReq, ProductReturn } from 'Store/return-order/types'
import { AppInput, AppSelect, AppTextArea, MultiUploadForm } from 'Components/form'
import OrderSummary from './OrderSummary'
import { PrimaryButton } from 'Components/button'
import { createReturnOrderAPI } from 'Store/return-order/api'
import { getUserLogin } from 'helpers/account'
import { selectReturnActionEvent } from 'Store/return-order/selector'
import { clearEventAction } from 'Store/return-order/actions'
import { ReturnTag } from 'Components/utilities'
import { ProductOptions } from 'Store/product/types'
import theme from 'Components/common/Theme'
import ProductUomSystemInfo from 'Pages/Product/components/ProductUomSystemInfo'

type Props = {
  visible: boolean
  onClose: () => void
  detail?: Data
  onSuccess?: () => void
} & ReduxProps

const ReturnDrawer = (props: Props) => {
  const { visible, onClose, currentUser, detail, event, onSuccess = () => {} } = props
  const products = detail?.products[0]?.products || []
  const initForm = {
    channel: 'pos',
    docs: [],
    officer: '',
    order_id: 0,
    order_no: '',
    products: [],
    return_type: '',
    reason: '',
    remark: '',
    other_reason: '',
  } as CreateReturnReq
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [selectProduct, setSelectProduct] = useState([] as ProductReturn[])
  const [formError, setFormError] = useState([] as string[])
  const normalRequireFeild = ['return_type', 'reason']
  const otherRequireFeild = ['return_type', 'reason', 'other_reason']
  const isOtherReason = formData.reason === 'other'
  const requireFeild = isOtherReason ? otherRequireFeild : normalRequireFeild
  const hasExcludeVat = detail?.payment_detail?.vat_type === VAT_TYPE.EX && detail?.payment_detail.is_tax
  const userInfo = getUserLogin()

  const dispatch = useDispatch()

  const onGetDetail = (): void => {}

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  const addProductVat = (selectProduct: ProductReturn[]) => {
    return selectProduct?.map(item => {
      const vat = item.return_amount * (7 / 100)
      item.return_amount = item.return_amount + vat
      return item
    })
  }

  const onCreate = (): void => {
    if (!validateForm()) return
    const req: CreateReturnReq = {
      ...formData,
      order_id: detail?.id || 0,
      order_no: detail?.order_no || '',
      officer: userInfo?.username || '',
      products: hasExcludeVat ? addProductVat(selectProduct) : selectProduct,
      channel: 'pos',
      reason: isOtherReason ? formData.other_reason : formData?.reason,
    }
    //console.log('req', req)
    dispatch(createReturnOrderAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormData(cloneDeep(initForm))
      setFormError([])
      setSelectProduct([])
    }

    // get detail on "edit" mode
    if (visible) {
      onGetDetail()
    }
  }, [visible])

  const onUpdateData = (val: string, key: string) => {
    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderImage = (product_option: any) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + product_option?.photo} fallback={ImageFallback} />
  )

  const renderProductName = (item: any, record: any) => {
    const isSameTitle = item.title == record.product_option?.title
    const isFlashSale = record.product_option?.promotion?.promotion_type === 'flash_sale'
    const promotionName = record.product_option?.promotion?.name || 'Promotion'
    return (
      <>
        <RowTile>{item.title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option?.title}</ProductDesc>}
        {isFlashSale && (
          <Tag icon={<ThunderboltOutlined />} color={Theme.colors.primary}>
            {promotionName}
          </Tag>
        )}
        {/* <ReturnTag isReturn={record?.product?.refund_status === 'Y'} /> */}
        <ReturnTag
          isReturn={record?.product?.return_qty > 0}
          returnQty={record?.product?.return_qty}
          returnUom={record?.product_uom_system}
        />
        {record.product_option.bom === 1 && <WarningText>*สินค้ามีส่วนประกอบ ไม่สามารถคืนได้</WarningText>}
      </>
    )
  }

  const isSelect = (productID: number, optionID: number) => {
    const data = selectProduct.find(
      item => item.product_id === productID && item.product_option_id === optionID,
    )
    return data ? true : false
  }

  const removeID = (productID: number, optionID: number) => {
    return selectProduct.filter(
      (item: ProductReturn) => item.product_id !== productID || item.product_option_id !== optionID,
    )
  }

  const onSelectProduct = (product: Product) => {
    let newSelect = cloneDeep(selectProduct) || []
    if (isSelect(product.product_id, product.product_option_id)) {
      newSelect = removeID(product.product_id, product.product_option_id)
    } else {
      const quantityRemain =
        product?.product?.return_available?.find(item => item.product_uom_id === product?.product_uom_id)
          ?.available_return_qty || 0
      newSelect.push({
        product_id: product.product_id,
        product_option_id: product.product_option_id,
        return_amount: quantityRemain <= 0 ? 0 : product.product_option.price,
        return_qty: quantityRemain > 1 ? 1 : quantityRemain,
        id: product.id,
        product_uom_id: product.product_uom_id || 0,
      })
    }
    setSelectProduct([...newSelect])
  }

  const onUpdatePrice = (product: Product, val: string, return_qty: number) => {
    const newProduct =
      selectProduct &&
      selectProduct.map(item => {
        if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
          const isMaster = product.product_uom_id === item.product_uom_id
          const pricePerUnit = isMaster
            ? product.product_option.price
            : product.product_option.price / (product.multiplier || 1)
          const totalPrice = (return_qty || 0) * pricePerUnit
          item.return_amount = parseFloat(val) > totalPrice ? totalPrice : parseFloat(val)
          //item.return_amount = parseFloat(val)
        }
        return item
      })
    setSelectProduct([...newProduct])
  }

  const onUpdateReturnQty = (product: Product, val: string) => {
    const newProduct =
      selectProduct &&
      selectProduct.map(item => {
        if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
          const isMaster = product.product_uom_id === item.product_uom_id
          const pricePerUnit = isMaster
            ? product.product_option.price
            : product.product_option.price / (product.multiplier || 1)
          const totalPrice = (parseFloat(val) || 0) * pricePerUnit
          item.return_qty = parseFloat(val)
          item.return_amount = totalPrice
        }
        return item
      })
    setSelectProduct([...newProduct])
  }

  const onUpdateReturnUom = (product: Product, val: string) => {
    const newProduct =
      selectProduct &&
      selectProduct.map(item => {
        if (item.product_id === product.product_id && item.product_option_id === product.product_option_id) {
          const newUomId = parseInt(val)
          const isMaster = product.product_uom_id === newUomId
          const quantityRemain =
            product?.product?.return_available?.find(item => item.product_uom_id === newUomId)
              ?.available_return_qty || 0
          const pricePerUnit = isMaster
            ? product.product_option.price
            : product.product_option.price / (product.multiplier || 1)
          item.product_uom_id = newUomId
          item.return_qty = quantityRemain > 1 ? 1 : quantityRemain
          item.return_amount = quantityRemain <= 0 ? 0 : pricePerUnit
          //get price of uom
        }
        return item
      })
    setSelectProduct([...newProduct])
  }

  const renderPrice = (item: string, record: Product) => {
    const enable = isSelect(record.product_id, record.product_option_id)
    const data = selectProduct.find(
      item => item.product_id === record.product_id && item.product_option_id === record.product_option_id,
    )
    return (
      <>
        <AppInput
          name="price"
          label=""
          type="number"
          errorMsg="ยอดเงินคืน"
          isRequired={true}
          //isError={enable && (isNaN(data?.return_amount || 0) || (data?.return_amount || 0) <= 0)}
          value={roundNumber(data?.return_amount)}
          onChange={val => onUpdatePrice(record, val, data?.return_qty || 0)}
          key={`${record.product_id}-${record.product_option_id}`}
          resProps={{
            disabled: !enable,
            allowClear: false,
          }}
        />
      </>
    )
  }

  const renderReturnQty = (item: string, record: Product) => {
    const enable = isSelect(record.product_id, record.product_option_id)
    const data = selectProduct.find(
      item => item.product_id === record.product_id && item.product_option_id === record.product_option_id,
    )
    const isSystem = data?.product_uom_id === record.product_uom_id_system
    const quantity = isSystem ? record.quantity_system || 0 : record.quantity
    const uom = isSystem ? record.product_uom_system || '' : record.product_uom || ''
    const quantityRemain =
      record?.product?.return_available?.find(item => item.product_uom_id === data?.product_uom_id)
        ?.available_return_qty || 0

    return (
      <AppSelect
        name="return_qty"
        label=""
        isRequired={isRequired('return_qty')}
        isError={isError('return_qty')}
        value={data?.return_qty}
        onChange={val => onUpdateReturnQty(record, val)}
        menu={getQtyMenu(quantityRemain, uom)}
        disabled={!enable}
        allowClear={false}
        placeHolder="0"
      />
    )
  }

  const renderActionButton = (id: number, record: Product) => {
    const quantityRemain =
      record?.product?.return_available?.find(item => item.product_uom_id === record?.product_uom_id_system)
        ?.available_return_qty || 0
    const disable = quantityRemain <= 0 || record?.product_option?.bom === 1
    return (
      <Space size="small" wrap={true} direction="vertical">
        <Checkbox
          onChange={() => onSelectProduct(record)}
          checked={isSelect(record.product_id, record.product_option_id)}
          //disabled={record?.product?.refund_status === 'Y'}
          disabled={disable}
        />
      </Space>
    )
  }

  const renderQuantity = (quantity: number, record: Product) => {
    const uom = (
      <ProductUomSystemInfo
        multiplier={record.multiplier}
        quantity={record.quantity}
        uom={record.product_uom || ''}
        quantitySystem={record.quantity_system || 0}
        uomSystem={record.product_uom_system || ''}
        showQuantity={true}
      />
    )
    return (
      <Space>
        {numberWithComma(quantity)}
        {uom}
      </Space>
    )
  }

  const renderProductUom = (uom: string, record: Product) => {
    if (uom == record.product_uom_system) {
      return <div>{uom}</div>
    } else {
      const enable = isSelect(record.product_id, record.product_option_id)
      const data = selectProduct.find(
        item => item.product_id === record.product_id && item.product_option_id === record.product_option_id,
      )
      return (
        <div>
          <AppSelect
            name="product_uom_id"
            label=""
            isRequired={true}
            isError={false}
            value={data?.product_uom_id}
            onChange={val => onUpdateReturnUom(record, val)}
            menu={getUomReturnMenu(
              record?.product_uom_id || 0,
              record.product_uom || '',
              record.product_uom_id_system || 0,
              record.product_uom_system || '',
            )}
            disabled={!enable}
            allowClear={false}
            placeHolder="0"
          />
        </div>
      )
    }
  }

  const columns = [
    // {
    //   title: <ColTile>ลำดับ</ColTile>,
    //   dataIndex: 'no',
    //   key: 'no',
    //   // eslint-disable-next-line react/display-name
    //   render: (value: any, record: any, index: number) => {
    //     return renderInfo(index + 1)
    //   },
    //   width: '50px',
    // },
    {
      //title: <Checkbox onChange={onSelectAll} checked={isSelectAll()}></Checkbox>,
      title: 'เลือก',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
      width: '80px',
      align: 'center',
    },
    {
      title: <ColTile>รูปภาพ</ColTile>,
      dataIndex: 'product_option',
      key: 'product_option',
      width: '80px',
      render: renderImage,
    },
    {
      title: <ColTile>รหัสสินค้า</ColTile>,
      dataIndex: 'product',
      key: 'product-code',
      render: (product: any) => renderInfo(product?.code || '-'),
    },
    {
      title: <ColTile>รายการ</ColTile>,
      dataIndex: 'product',
      key: 'product-title',
      render: renderProductName,
      width: '150px',
    },
    {
      title: <ColTile>ยี่ห้อ</ColTile>,
      dataIndex: 'product',
      key: 'manufacturer',
      render: (product: any) => renderInfo(product?.manufacturer?.name || '-'),
    },
    {
      title: <ColTile>จำนวน(ซื้อ)</ColTile>,
      dataIndex: 'quantity',
      key: 'quantity',
      width: '120px',
      render: renderQuantity,
    },
    // {
    //   title: <ColTile>หน่วย(ขาย)</ColTile>,
    //   dataIndex: 'product_uom',
    //   key: 'product_uom',
    //   //render: renderProductUom,
    // },
    {
      title: <ColTile>ราคา/หน่วย</ColTile>,
      dataIndex: 'product_option',
      key: 'product_option',
      width: '80px',
      render: (product_option: ProductOptions) =>
        renderInfo(numberWithComma(product_option?.price || 0, true)),
    },
    {
      title: <ColTile>เลือกหน่วยที่ต้องการคืน</ColTile>,
      dataIndex: 'product_uom',
      key: 'product_uom',
      width: '120px',
      render: renderProductUom,
    },
    // {
    //   title: (
    //     <ColTile>
    //       ราคารวม
    //       <ProductDesc>(ก่อนหักส่วนลด)</ProductDesc>
    //     </ColTile>
    //   ),
    //   dataIndex: 'price_before_discount',
    //   key: 'price_before_discount',
    //   render: (price: number) => renderInfo(numberWithComma(price, true)),
    // },
    // {
    //   title: <ColTile>ส่วนลด</ColTile>,
    //   dataIndex: 'total_discount',
    //   key: 'total_discount',
    //   render: (price: number) => renderInfo(numberWithComma(price, true)),
    // },
    // {
    //   title: <ColTile>ราคารวม</ColTile>,
    //   dataIndex: 'total_price',
    //   key: 'total_price',
    //   render: (price: number) => renderInfo(numberWithComma(price, true)),
    // },
    {
      title: 'จำนวนที่คืน',
      dataIndex: 'return_qty',
      key: 'return_qty',
      render: renderReturnQty,
      width: '120px',
    },
    {
      title: <ColTile>ยอดเงินคืน</ColTile>,
      dataIndex: 'total_discount',
      key: 'total_discount',
      render: renderPrice,
      width: '150px',
    },
  ]

  const renderFormReturn = () => {
    return (
      <Row gutter={[16, 8]}>
        <Col md={12} xs={24}>
          {/* <AppInput
            name="reason"
            label="เหตุผลการคืน"
            isRequired={isRequired('reason')}
            isError={isError('reason')}
            value={formData.reason}
            onChange={onUpdateData}
          /> */}
          <AppSelect
            name="reason"
            label="เหตุผลการคืน"
            placeHolder="เลือกเหตุผลการคืน"
            isRequired={isRequired('reason')}
            isError={isError('reason')}
            value={formData.reason}
            onChange={onUpdateData}
            menu={menuReturnReason}
            allowClear={false}
          />
          {isOtherReason && (
            <AppInput
              name="other_reason"
              label="ระบุเหตุผล"
              isRequired={true}
              isError={isError('other_reason')}
              value={formData.other_reason}
              onChange={onUpdateData}
            />
          )}
        </Col>
        <Col xs={24} md={12}>
          <AppSelect
            name="return_type"
            label="ช่องทางการรับเงินคืน"
            placeHolder="เลือกช่องทางการรับเงินคืน"
            isRequired={isRequired('return_type')}
            isError={isError('return_type')}
            value={formData.return_type}
            onChange={onUpdateData}
            menu={menuReturnPaymentTypes}
            allowClear={false}
          />
        </Col>

        {/* <Col xs={24} md={12}></Col> */}
        <Col md={12} xs={24}>
          <AppTextArea
            label="หมายเหตุ (ถ้ามี)"
            isRequired={isRequired('remark')}
            isError={isError('remark')}
            name="remark"
            rows={3}
            value={formData.remark}
            onChange={onUpdateData}
          />
        </Col>
        <Col xs={24} md={24}>
          <MultiUploadForm
            token={currentUser.accessToken}
            onUpdateData={onUpdateData}
            files={formData.docs}
            folder="order-return-documents"
            listType="text"
            isPrivate={true}
            name="docs"
            description="ขนาดไม่เกิน 5MB ต่อไฟล์ (.png .jpg .pdf)"
            isRequired={isRequired('docs')}
            isError={isError('docs')}
            label="แนบหลักฐาน/รูปภาพ/เอกสาร (ถ้ามี)"
          />
        </Col>
      </Row>
    )
  }

  const countReturnVal = () => {
    let total = 0
    selectProduct.forEach(item => {
      total += item.return_amount || 0
    })
    return total
  }

  const countReturnTotal = () => {
    const total = countReturnVal()
    const vat = hasExcludeVat ? countReturnVat() : 0
    return total + vat
  }

  const countReturnVat = () => {
    const returnVal = countReturnVal()
    const vat = returnVal * (7 / 100)
    return vat
  }

  const renderFooterContent = () => {
    return (
      <Row justify="end" align="middle" gutter={[8, 8]}>
        <Col>
          <Space>
            ยอดเงินคืนสุทธิ <Bold>{numberWithComma(countReturnTotal(), true)}</Bold> บาท
          </Space>
        </Col>
        <Col>
          <PrimaryButton
            btnType="Primary"
            text={`ยืนยันสร้างรายการรับคืนสินค้า`}
            onClick={onCreate}
            disabled={selectProduct.length <= 0 || countReturnTotal() <= 0}
          />
        </Col>
      </Row>
    )
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    clearEvent()
    onSuccess()
  }

  const filterProducts = (products: Product[]) => {
    return products && products?.filter(item => item?.product_option?.bom !== 1)
  }

  return (
    <DetailDrawer
      title={`สร้างรายการรับคืนสินค้า เลขที่สั่งซื้อ : ${detail?.order_no}`}
      width={'90%'}
      onCloseDrawer={onClose}
      visible={visible}
      footer={renderFooterContent()}
      maskClosable={true}
    >
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      <Row>
        <Col md={24} xs={24}>
          <BoxWrapper>
            <BoxTitle>เลือกสินค้าที่ต้องการคืน</BoxTitle>
            <TableListPage
              columns={columns}
              //datas={filterProducts(products)}
              datas={products}
              size={'small'}
              scrollX={1000}
              // rowClassName={(record: Product) =>
              //   (record?.product?.return_qty || 0) >= record?.quantity || record?.product_option?.bom === 1
              //     ? 'row-disabled'
              //     : ''
              // }
              rowClassName={(record: Product) => {
                const quantityRemain =
                  record?.product?.return_available?.find(
                    item => item.product_uom_id === record?.product_uom_id_system,
                  )?.available_return_qty || 0
                const disable = quantityRemain <= 0 || record?.product_option?.bom === 1
                return disable ? 'row-disabled' : ''
              }}
            />
            {/* <OrderSummary detail={detail} />
            <Divider /> */}
            {/* {countReturnTotal() > 0 && (
              <Row justify="end">
                <Col md={12} xs={24}>
                  <Row justify="space-between">
                    <Col>
                      <Bold>ยอดเงินคืนสุทธิ</Bold>
                    </Col>
                    <Col offset={1}>
                      <Bold>{numberWithComma(countReturnTotal(), true)} บาท</Bold>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )} */}
            {hasExcludeVat && (
              <Row justify="end">
                <Col md={12} xs={24}>
                  <SummaryInfo>
                    <Row justify="space-between">
                      <Col>
                        <RowTile>รวมยอดเงินคืนสินค้า</RowTile>
                      </Col>
                      <Col offset={1}>
                        <RowTile>{numberWithComma(countReturnVal(), true)} บาท</RowTile>
                      </Col>
                    </Row>
                  </SummaryInfo>
                </Col>
              </Row>
            )}
            {hasExcludeVat && (
              <Row justify="end">
                <Col md={12} xs={24}>
                  <SummaryInfo>
                    <Row justify="space-between">
                      <Col>
                        <RowTile>คืน ภาษีมูลค่าเพิ่ม 7%</RowTile>
                      </Col>
                      <Col offset={1}>
                        <RowTile>{numberWithComma(countReturnVat(), true)} บาท</RowTile>
                      </Col>
                    </Row>
                  </SummaryInfo>
                </Col>
              </Row>
            )}
            <Row justify="end">
              <Col md={12} xs={24}>
                <SummaryInfo>
                  <Row justify="space-between">
                    <Col>
                      <Bold>ยอดเงินคืนสุทธิ</Bold>
                    </Col>
                    <Col offset={1}>
                      <Bold>{numberWithComma(countReturnTotal(), true)} บาท</Bold>
                    </Col>
                  </Row>
                </SummaryInfo>
              </Col>
            </Row>
          </BoxWrapper>
        </Col>
        <br />
        <Col md={24} xs={24}>
          <BoxWrapper>
            {/* <BoxTitle>รายละเอียดการคืน</BoxTitle> */}
            {renderFormReturn()}
          </BoxWrapper>
        </Col>
      </Row>
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.primary};
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 70px;
  height: 70px;
  object-fit: cover;
`

const ColTile = styled.span`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const WarningText = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const Bold = styled.span`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const Quantity = styled.span`
  text-decoration: line-through;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`
const SummaryInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  //color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-right: 20px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectReturnActionEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ReturnDrawer)
